import React from 'react';
import { IconProps } from '@perxis-auto/ui-kit/lib/components/Icon';

import { SEO } from '@/components/SEO';
import usePageReady from '@/features/installation/hooks/usePageReady';

import { ErrorMessage } from './components';
import { ErrorPageProps } from './Error.types';

const TRANSLATION_KEYS_MAP: Record<number, string> = {
  404: 'pageNotFound',
  500: 'pageInternalServer',
};

const ICON_NAMES: Record<number, IconProps['name']> = {
  404: 'notfound',
  500: 'wait',
};

function ErrorPage({ statusCode }: ErrorPageProps) {
  usePageReady({});

  return (
    <>
      <SEO title={`${statusCode}`}>
        <meta name="status" content={`${statusCode}`} />
      </SEO>
      <ErrorMessage
        translationKey={TRANSLATION_KEYS_MAP[statusCode] ?? TRANSLATION_KEYS_MAP[500]}
        iconName={ICON_NAMES[statusCode]}
      />
    </>
  );
}

export default React.memo(ErrorPage);
